import { createNewPrivateMessage } from "./helper";

const privateChat = (state = new Map(), action) => {
  switch (action.type) {
    case "ADD_NEW_PRIVATE_USER_MESSAGE": {
      const { text, displayName, senderId, selectedPeerId } = action.payload;
      const message = createNewPrivateMessage(
        text,
        "client",
        displayName,
        senderId,
        selectedPeerId
      );
      let chatId;
      if (senderId > selectedPeerId) chatId = senderId + selectedPeerId;
      else chatId = selectedPeerId + senderId;
      let isChatIdExist = state.get(chatId);
      if (isChatIdExist) {
        state.get(chatId).push(message);
      } else {
        state.set(chatId, []);
        state.get(chatId).push(message);
      }
      return new Map(state);
    }

    case "ADD_NEW_PRIVATE_RESPONSE_MESSAGE": {
      const { message } = action.payload;
      let chatId;
      if (message.senderId > message.selectedPeerId)
        chatId = message.senderId + message.selectedPeerId;
      else chatId = message.selectedPeerId + message.senderId;
      let isChatIdExist = state.get(chatId);
      if (isChatIdExist) {
        state.get(chatId).push(message);
      } else {
        state.set(chatId, []);
        state.get(chatId).push(message);
      }
      return new Map(state);
    }

    case "ADD_PRIVATE_CHAT_HISTORY": {
      const { privateChatHistory } = action.payload;
      return privateChatHistory;
    }

    case "CLEAR_STATE":
      return new Map();
    default:
      return state;
  }
};

export default privateChat;
